import styled from 'styled-components/macro'
import Icon from '../../../commons/Icon'

export const CatalogCart = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2.5rem;
  margin-right: 2rem;
  height: 72px;
  width: 72px;
  position: fixed;
  z-index: 10001;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.colors.primary.dark};
  box-shadow: ${({ theme }) => theme.shadows.dark};
  border-radius: 30%;
  cursor: pointer;
`

export const CartIcon = styled(Icon)`
  color: white;
  width: 40px;
  height: 40px;
  color: ${({ theme }) => theme.colors.mono.white};
`

export const CatalogCartWrapper = styled.div`
  position: absolute;
  display: flex;
`

export const CatalogCartQuantityQtd = styled.span`
  position: absolute;
  left: 24px;
  top: -0.5rem;
  padding: 0 0.8rem;
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize.md};
  line-height: 1.7rem;
  background: ${({ theme }) => theme.colors.secondary.default};
  border: 0.2rem solid ${({ theme }) => theme.colors.mono.white};
  border-radius: 10rem;
  color: ${({ theme }) => theme.colors.mono.black};
`